import webConfig from '../webconfig.json'
import axios from 'axios'

const TOKEN_KEY = `@${webConfig.nomeSistema}`
const USER_DATA = `@${webConfig.nomeSistema}-data`

export const getToken = () => localStorage.getItem(TOKEN_KEY)

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null

export const logout = () => {
    removeLocalStorageData()
    window.location.href = 'http://tcenet.tce.gti.br/'
}

export const removeLocalStorageData = () => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_DATA)
}

export const getUserData = () => localStorage.getItem(USER_DATA)

export const validaToken = async () => {
    let dataUser = JSON.parse(getUserData())
    await axios({
        method: 'get',
        url: `${webConfig.ApiLogin}/api/v1/Autenticacao/valida/token?usuarioId=${dataUser.id}&tipoUsuario=0`,
        headers: {
            'accept': 'text/plain',
            'token': getToken()
        }
    })
        .catch(error => {
            logout()
        })
}

export const realizaLoginPorChave = async (chaveLogin, setLoading) => {
    await axios({
        method: 'post',
        url: `${webConfig.ApiLogin}/api/v1/Autenticacao/login/${chaveLogin}`,
        headers: {
            'accept': 'text/plain'
        }
    }).then(response => {
        localStorage.setItem(TOKEN_KEY, response.data.accessToken);
        localStorage.setItem(USER_DATA, JSON.stringify({
            id: response.data.id,
            nome: response.data.nome,
            setor: response.data.nomeSetor,
            email: response.data.email
        }));
        setLoading(false);
    }).catch(error => {
        console.log(error);
        setLoading(false);
    })
}